import script from "./TheBreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./TheBreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./TheBreadCrumbs.vue?vue&type=style&index=0&id=6a5752c4&lang=css"

const __exports__ = script;

export default __exports__